export default __webpack_public_path__ + "static/media/angelie4.7997d4ab.jpg";